export default function NotFoundPage() {
  return (
    <div>
      <h2>404 Not Found</h2>
      <a href="/">메인으로 이동</a>
    </div>
  )
}
